import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HighchartsChartModule } from 'highcharts-angular';

import { SharedDependenciesModule } from '../../../../shared/shared-dependencies.module';
import { DiagnosticsModule } from '../extended-parameters/diagnostics.module';

import { ActiveErrorBlurComponent } from './active-error-blur/active-error-blur.component';
import { WarningBoxComponent } from './active-error-blur/warning-box/warning-box.component';
import { ActiveErrorDetailsComponent } from './active-error-details/active-error-details.component';
import { EcuComponent } from './active-error-details/ecu/ecu.component';
import { HowToRepairComponent } from './active-error-details/how-to-repair/how-to-repair.component';
import { PossibleCauseComponent } from './active-error-details/possible-cause/possible-cause.component';
import { SystemBehaviorComponent } from './active-error-details/system-behavior/system-behavior.component';
import { ActiveErrorDiagnosticsComponent } from './active-error-diagnostics/active-error-diagnostics.component';
import { FreezeFrameComponent } from './active-error-diagnostics/freeze-frame/freeze-frame.component';
import { ShowLiveVddTableItemComponent } from './active-error-diagnostics/show-live-vdd-table-item/show-live-vdd-table-item.component';
import { ShowLiveVddComponent } from './active-error-diagnostics/show-live-vdd/show-live-vdd.component';
import { ActiveErrorTileComponent } from './active-errors-list/active-error-tile/active-error-tile.component';
import { ActiveErrorsListComponent } from './active-errors-list/active-errors-list.component';
import { GuidedTroubleshootingComponent } from './guided-troubleshooting.component';
import { LegacyDeviceNoteComponent } from './legacy-device-note/legacy-device-note.component';
import { DomSanitizerPipe } from '../../../../shared/pipes/dom-sanitizer/dom-sanitizer.pipe';
import { GtsHtmlTagsPipe } from './active-error-details/how-to-repair/pipes/gts-html-tags.pipe';

@NgModule({
  imports: [
    SharedDependenciesModule,
    HighchartsChartModule,
    RouterModule,
    DiagnosticsModule,
    DomSanitizerPipe,
    GtsHtmlTagsPipe,
  ],
  exports: [GuidedTroubleshootingComponent],
  declarations: [
    ActiveErrorTileComponent,
    ActiveErrorsListComponent,
    GuidedTroubleshootingComponent,
    ActiveErrorDetailsComponent,
    ActiveErrorBlurComponent,
    PossibleCauseComponent,
    SystemBehaviorComponent,
    EcuComponent,
    HowToRepairComponent,
    LegacyDeviceNoteComponent,
    ActiveErrorDiagnosticsComponent,
    FreezeFrameComponent,
    ShowLiveVddComponent,
    WarningBoxComponent,
    ShowLiveVddTableItemComponent,
  ],
  providers: [],
})
export class GuidedTroubleshootingModule {}
